<template>
  <BoardView :title="$t('title')">
    <FormValidation @submit="create">
      <FormBlueprints
        :value.sync="blueprintsSchemes" />
      <Btn
        class="info"
        :isLoading="isSaving"
        type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormBlueprints from './components/FormBlueprints'
import { actions } from '@utils'

export default {
  mixins: [
    BoardAdd('articleBlueprint', {
      redirectTo: 'ArticleTable',
      stateKey: null,
      successMessage: self => self.$t('done'),
    }),
  ],
  components: { FormBlueprints },
  data() {
    return {
      blueprintsSchemes: [],
    }
  },
  methods: {
    createDirect() {
      return this.BUILD_ARTICLE_BLUEPRINTS(this.blueprintsSchemes)
    },
    ...actions('BUILD_ARTICLE_BLUEPRINTS'),
  },
}
</script>

<i18n>
{
  "en": {
    "done": "Jobs added",
    "submit": "Add jobs",
    "title": "Add article batch"
  }
}
</i18n>
